import React, { useState } from "react";
import { formatDateCST, formatTimeCST } from "../utlis";

const CandiDateNewNote = ({ notesData = {} }) => {
    const [isNoteOpen, setIsOpen] = useState(false);

    return (
        <div
            className={`w-full ${isNoteOpen ? "h-44" : "h-28"
                } border border-zinc-100 flex-col justify-start items-start inline-flex`}
        >
            <div className="flex justify-between items-center w-full p-3 text-xs text-text-hint">
                <div className="flex items-center gap-2">
                    {isNoteOpen ? (
                        <svg
                            onClick={() => setIsOpen(!isNoteOpen)}
                            width="14"
                            height="9"
                            viewBox="0 0 14 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="cursor-pointer"
                        >
                            <path
                                id="Vector 9"
                                d="M13.002 1.35339L7.00195 7.35339L1.00195 1.35339"
                                stroke="#00ABB6"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    ) : (
                        <svg
                            onClick={() => setIsOpen(!isNoteOpen)}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="cursor-pointer"
                        >
                            <g id="icon">
                                <path
                                    id="Vector 9"
                                    d="M5.33545 1.87048L11.3354 7.87048L5.33545 13.8705"
                                    stroke="#00ABB6"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </g>
                        </svg>
                    )}

                    <span className="font-normal text-black text-xs">Notes</span>

                    <p>By {notesData.created_by || 'Unknown'}</p>
                    {notesData.created && (
                        <span className="ml-1">
                            {formatDateCST(notesData.created)}
                            <span className="text-[10px] text-gray-400 ml-1">{formatTimeCST(notesData.created)}</span>
                        </span>
                    )}
                </div>
            </div>
            {isNoteOpen ? (
                <div className="flex px-8 w-full h-44 overflow-y-auto">
                    <p className="text-justify pb-4 text-xs">
                        {notesData.notes}
                    </p>
                </div>
            ) : (
                <div className="flex px-8 w-full">
                    <p className="line-clamp-3 text-justify text-xs">
                        {notesData.notes}
                    </p>
                </div>
            )}
        </div>
    );
};

export default CandiDateNewNote;
